import React from 'react';
import { Chip } from '@mui/material';
import DataGrid from '../../../../../table/DataGrid';
import IconTooltipButton from '../../../../../button/IconTooltipButton';

const List = ({ isLoading, list, permissions, onAction }) => {
  const columnsTable = [
    {
      show: true,
      key: 'position',
      align: 'center',
      hide: false,
      width: 5,
      label: 'position'
    },
    {
      show: true,
      key: 'code',
      align: 'center',
      hide: false,
      width: 5,
      label: 'Code'
    },
    {
      show: true,
      key: 'primary',
      align: 'left',
      hide: false,
      width: 200,
      label: 'Name'
    },

    {
      show: permissions['preview'] || permissions['updated'] || permissions['deleted'],
      key: 'actions',
      align: 'center',
      hide: false,
      width: 50,
      label: 'actions'
    }
  ];

  return (
    <DataGrid
      id='special-circumstances-periodical-report'
      showSetting={false}
      rowsPerPage={list?.length || 10}
      groupBy={'curriculum'}
      rows={list.map((row) => {
        return {
          ...row,
          code: <Chip label={row.code} size='small' className='min-w-60px' />,
          primary: (
            <div className='py-1'>
              <p>{row.name}</p>
              <p className='text-xs text-muted-foreground opacity-50'>{row.description}</p>
            </div>
          ),
          actions: (
            <div>
              {permissions['preview'] && (
                <IconTooltipButton
                  title='Preview'
                  icon='expand-alt'
                  onClick={() => onAction('preview', row)}
                />
              )}
              {permissions['updated'] && (
                <IconTooltipButton
                  title='Edit'
                  icon={['fas', 'edit']}
                  onClick={() => onAction('edit', row)}
                />
              )}
              {permissions['deleted'] && (
                <IconTooltipButton
                  title='Delete'
                  icon={['fas', 'trash-alt']}
                  onClick={() => onAction('delete', row)}
                />
              )}
            </div>
          )

        };
      })}
      loading={isLoading}
      columns={columnsTable}
      labelNoRows="You don't have any special circumstances yet"
    />
  );
};

export default List;
